export class ClienteModel {
    constructor(
        public idcliente: number,
        public saldomora: string,
        public estado: boolean
    ) { }
}